import { ContentItemTypes } from 'modules/Boards/Types';
import AddToMyBoards from '../components/addToMyBoards';

const addToBoardBtn = document.getElementById('add-to-board');
const addArticleToBoardBtn = document.getElementById('add-article-to-board');

function addToBoard(e) {
  const title = e.currentTarget.getAttribute('data-blog-title');
  AddToMyBoards.openModal(ContentItemTypes.article, null, null, title);

  // GTM track Add to Board CTA Click
  window.dataLayer.push({
    'event': 'board-cta-click',
    'clickText': e.target.innerText.slice(1), //remove preceeding space
    'pageLocation': location.pathname,
  })
}

$(addToBoardBtn).on('click', addToBoard);
$(addArticleToBoardBtn).on('click', addToBoard);
